import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Progress } from 'web-library';
import RouteKey from '../../../../routes/key';
import { candidateService } from '../../../../api';
import { UpdateResitCandidateSelectedSubjects } from '../../../../store/resitSlice';
import TransactionDetail from '../TransactionDetail';
import { parseLocationSearch } from '../../../../utils/StringUtils';
import { useWOGAA } from '../../../../hooks/wogaa';

import { useGetCheckRegistrationStatus } from '../../../../api-refactored/resit-registration/useGetCheckRegistrationStatus';

const { amendment, paymentLink } = RouteKey.child;
const { summary: paymentSummary, amendmentRegistration } = RouteKey['payment-link'].child;

const { viewDetails, examRegistrations } = RouteKey.amendment.child;

const useStyles = makeStyles()((theme) =>
({
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
}));

const ResitReceipt = ({ isPaymentLink = false }: { isPaymentLink?: boolean }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const { search, state: candidateApplicationUuid } = useLocation<string>();
  const { internalTransactionRef } = parseLocationSearch(search);
  const { transactionEnd } = useWOGAA('myexamsseab-3753');

  const [checkingStatusEnable, setCheckingStatusEnable] = useState(!isPaymentLink);

  /** WOGAA complete transaction for resit flow
   * */
  transactionEnd(candidateApplicationUuid);

  /** to get resit payment transaction
   * */
  const { data } = candidateService.resit.candidate.useGetCandidateResitTransaction(
    internalTransactionRef,
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: !checkingStatusEnable,
    }
  );

  useEffect(() => {
    dispatch(UpdateResitCandidateSelectedSubjects([]));
  }, [dispatch]);

  useGetCheckRegistrationStatus({
    uuid: candidateApplicationUuid,
    enabled: checkingStatusEnable,
    onSuccess: (res) => {
      setCheckingStatusEnable(!res);
    },
  });

  if (checkingStatusEnable) {
    return <Progress color="secondary" />;
  }

  const toSummary = () => {
    const summaryPath = isPaymentLink
      ? `/${paymentLink}/${amendmentRegistration}/${candidateApplicationUuid}/${paymentSummary}`
      : `/${amendment}/${examRegistrations.route}/${candidateApplicationUuid}/${viewDetails.route}`;

    history.push(summaryPath);
  };

  return (
    <>
      <TransactionDetail
        transaction={{
          transactionNumber: data?.transactionNumber || '',
          internalTransactionRef: data?.internalTransactionRef,
          totalFee: data?.totalFee || '0',
          paymentMethod: data?.paymentMethod || '',
          paymentTimeStamp: data?.paymentTimeStamp || '',
          gstRegNo: data?.gstRegNo,
          examLevel: data?.examLevel,
          examYear: data?.examYear,
        }}
        toSummary={toSummary}
      />

      {!isPaymentLink && (
        <Button
          id="button-resitReceipt-goToRegisteredExams"
          className={classes.button}
          onClick={() => history.push(`/${amendment}/${examRegistrations.route}`)}
        >
          {t('resit->>ResitReceipt.View Registered Exams')}
        </Button>
      )}
    </>
  );
};

export default ResitReceipt;
